module.exports = __webpack_public_path__ + "static/media/GoldenAge.1fe4db30.jpg";